module.exports = __webpack_public_path__ + "static/media/ICON_HOME.d7b004c4.svg";